import React, { useState } from "react";
import {
  Box,
  TextField,
  Menu,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch } from "react-redux";
import { updateStringField } from "../../../../store/slices/pva_testReport.slices";
import "./strStyle.css";
import { stringFields } from "../../../data/strInfo_data";

export default function StringInfo({
  inverterIndex,
  mpptIndex,
  stringIndex,
  stringData,
}) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDropdownSelect = (value, field) => {
    dispatch(
      updateStringField({ inverterIndex, mpptIndex, stringIndex, field, value })
    );
    setAnchorEl(null);
    setActiveDropdown(null);
  };

  const openDropdown = (event, field) => {
    setAnchorEl(event.currentTarget);
    setActiveDropdown(field);
  };

  const fields = stringFields(stringData);

  return (
    <Box className="string-section">
      {fields.map(({ label, field, value, type, options }) => {
        const isDropdown = type === "dropdown" || type === "hybrid";

        return (
          <Box
            key={field}
            sx={{ display: "flex", alignItems: "center", mb: 1 }}
          >
            <TextField
              fullWidth
              className="string-textfield"
              size="small"
              label={label}
              value={value}
              onChange={(e) => {
                if (type === "number" || type === "hybrid") {
                  let val = e.target.value;
                  val = val.replace(/[^\d.]/g, "");
                  const parts = val.split(".");
                  if (parts.length > 2) val = parts[0] + "." + parts[1];
                  dispatch(
                    updateStringField({
                      inverterIndex,
                      mpptIndex,
                      stringIndex,
                      field,
                      value: val,
                    })
                  );
                }
              }}
              InputProps={{
                endAdornment:
                  isDropdown && options ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={(e) => openDropdown(e, field)}
                      >
                        <ArrowDropDownIcon />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
              }}
            />

            {isDropdown && options && (
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl) && activeDropdown === field}
                onClose={() => {
                  setAnchorEl(null);
                  setActiveDropdown(null);
                }}
              >
                {options.map((opt) => (
                  <MenuItem
                    key={opt}
                    onClick={() => handleDropdownSelect(opt, field)}
                  >
                    {opt}
                  </MenuItem>
                ))}
              </Menu>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
